import axios from "axios";
import {ShopifyStoreFrontAccessToken, ShopifyStoreLink, ShopifyStoreLink2210} from "../../GlobalVar";

export const shopifyAxios = axios.create({
    baseURL: ShopifyStoreLink,
    headers: {
        'Content-Type': 'application/graphql',
        'X-Shopify-Storefront-Access-Token': ShopifyStoreFrontAccessToken,
    }
});

export const shopifyAxiosUpdated = axios.create({
    baseURL: ShopifyStoreLink2210,
    headers: {
        'Content-Type': 'application/graphql',
        'X-Shopify-Storefront-Access-Token': ShopifyStoreFrontAccessToken,
    }
});